import { Button, Flex, Heading, Icon, Tag } from "@chakra-ui/react";
import { FiCornerUpLeft } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import type { SourcingEventDto } from "../../../../../autogen/bff-api";
import { LastChangedTag } from "../../../../../common/editing/LastChangedTag/LastChangedTag";
import { useProcurementTerms } from "../../../../../common/terminology/useProcurementTerms";

interface Props {
  title: string;
  modifiedAt: string;
  contextType: SourcingEventDto["eventContext"]["type"];
  isChangeInFlight: boolean;
  onOpenFrameworkAgreement?: () => void;
  isOpeningFrameworkAgreement?: boolean;
}

export const EventHeader = ({
  title,
  modifiedAt,
  contextType,
  isChangeInFlight,
  onOpenFrameworkAgreement,
  isOpeningFrameworkAgreement = false,
}: Props) => {
  const { t } = useTranslation();
  const terms = useProcurementTerms();
  const untitledLabel =
    contextType === "Public"
      ? t("New public sourcing event")
      : contextType === "Private"
        ? terms.newSimplifiedDraft
        : t("New sourcing event");

  return (
    <>
      <Heading
        as="h1"
        size="md"
        width="full"
        textOverflow="ellipsis"
        overflow="hidden"
        whiteSpace="nowrap"
        mb="2"
      >
        {title || untitledLabel}
      </Heading>
      {onOpenFrameworkAgreement && (
        <Button
          variant="link"
          size="sm"
          colorScheme="teal"
          mb="2"
          leftIcon={<Icon as={FiCornerUpLeft} />}
          onClick={onOpenFrameworkAgreement}
          isLoading={isOpeningFrameworkAgreement}
        >
          {t("Part of a framework agreement")}
        </Button>
      )}
      <Flex columnGap="1">
        <Tag size="sm" colorScheme={isChangeInFlight ? "orange" : "teal"} variant="subtle">
          {isChangeInFlight ? t("Change in progress") : t("Draft")}
        </Tag>
        <LastChangedTag timestamp={modifiedAt} />
      </Flex>
    </>
  );
};
